import { render, staticRenderFns } from "./OneAndMore.vue?vue&type=template&id=fcf247cc&scoped=true&"
import script from "./OneAndMore.vue?vue&type=script&lang=js&"
export * from "./OneAndMore.vue?vue&type=script&lang=js&"
import style0 from "./OneAndMore.vue?vue&type=style&index=0&id=fcf247cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf247cc",
  null
  
)

export default component.exports